import React, { useState, useEffect } from 'react';
import { IAbcList, IAbcListButton } from '../../../domain/abc-list.interface';
import * as _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAssetUrl } from '../../../utils/GetAssetUrl';
import './AbcList.component.scss';

export function AbcListComponent(props: IAbcList) {
  const { groupKey, list, buttonsA, buttonsB } = props;
  const [groupElementsState, setGroupElementsState] = useState<any>({});
  const [groupLabelKeys, setGroupLabelKeys] = useState<string[]>(
    Object.keys(groupElementsState),
  );

  useEffect(() => {
    generateGroupList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list]);

  function generateGroupList() {
    let groupElements: any = {};
    _.sortBy(list, [groupKey]).forEach(element => {
      const groupLabel = String(element[groupKey][0]).toUpperCase();
      if (!groupElements.hasOwnProperty(groupLabel)) {
        groupElements = {
          ...groupElements,
          [groupLabel]: [],
        };
      }
      groupElements[groupLabel] = [...groupElements[groupLabel], element];
    });
    setGroupElementsState(groupElements);
    setGroupLabelKeys(Object.keys(groupElements));
  }

  function buttonAction(
    e: any,
    buttonFunction: (itemList: any) => void,
    itemList: any,
  ) {
    e.stopPropagation();
    if (buttonFunction) {
      return buttonFunction(itemList);
    } else {
      return null;
    }
  }

  function generateButtons(itemList: any, switcher?: boolean) {
    if (buttonsB && !!buttonsB.length && switcher) {
      return (
        <div className='button-list-container'>
          {buttonsB.map((button: IAbcListButton, indexBtn: number) => {
            return (
              <div
                key={indexBtn}
                onClick={e => buttonAction(e, button.action, itemList)}
              >
                {button.image && <img src={button.image} alt='' />}
                {button.icon && <FontAwesomeIcon icon={button.icon} />}
                {button.label && <FormattedMessage id={button.label} />}
              </div>
            );
          })}
        </div>
      );
    }
    if (buttonsA && !!buttonsA.length) {
      return (
        <div className='button-list-container'>
          {buttonsA.map((button: IAbcListButton, indexBtn: number) => {
            return (
              <div
                key={indexBtn}
                onClick={e => buttonAction(e, button.action, itemList)}
              >
                {button.image && <img src={button.image} alt='' />}
                {button.icon && <FontAwesomeIcon icon={button.icon} />}
                {button.label && <FormattedMessage id={button.label} />}
              </div>
            );
          })}
        </div>
      );
    }
  }

  return (
    <div className='abc-list-container'>
      {groupLabelKeys.map((groupLabel: string, indexGroupLabel) => {
        return (
          <div key={indexGroupLabel} className='group-list-container'>
            <div className='key-text'>{groupLabel}</div>
            <div className='group-list'>
              {groupElementsState[groupLabel].map(
                (itemList: any, index: number) => {
                  return (
                    <div
                      key={index}
                      className={`item-container d-flex align-items-center ${
                        itemList.user.isActive ? 'active' : 'inactive'
                      }`}
                    >
                      <div className='itemlist-image'>
                        {itemList.user.userPhoto ? (
                          <div
                            style={{
                              backgroundImage: `url(${getAssetUrl.imagesStatic(
                                itemList.user.userPhoto,
                              )})`,
                            }}
                          />
                        ) : (
                          <div className='icon-container d-flex justify-container-center align-items-center'>
                            <FontAwesomeIcon icon='user' />
                          </div>
                        )}
                      </div>
                      <div className='text'>{itemList[groupKey]}</div>
                      {generateButtons(itemList, !itemList.user.isActive)}
                    </div>
                  );
                },
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
